import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import {
  type SocietyIdentityParamsInput,
  type SocietyIdentityOutput,
} from "shared/api/types/society/[societyId]/identity/index";
/**
 * Always answers `exists`: whether the user name is already a login in the
 * society.  Society admins holding manage_identity additionally get the
 * identities that own it and the matching Cognito users.
 *
 * Throws (via PillarError) when the society has no identity provider or the
 * Cognito lookup fails, so callers should surface the error message.
 */
export const getSocietyIdentityContract: BaseApiContract<
  SocietyIdentityParamsInput,
  undefined,
  SocietyIdentityOutput
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/identity",
  paramsType: {} as SocietyIdentityParamsInput,
  responseType: {} as SocietyIdentityOutput,
};
